
const NS = 'SettingsBlockoutEventsCtrl';

export default function SettingsBlockoutEventsCtrl()
{
  "ngInject";

  const vm = this;
//rendering react component


}